<script>
import NavBar from '@components/nav-bar.vue'
import Footer from '@components/site-footer.vue'

export default {
  components: { NavBar, Footer },
  data() {
    return {
      showNavbar: false, // window.localStorage.getItem('appLogin') !== 'true'
    }
  },
}
</script>

<template>
  <div :class="$style.container">
    <NavBar v-if="showNavbar" />
    <slot />
    <Footer v-if="showNavbar" />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  min-width: $size-content-width-min;
  max-width: 100%;
  margin: 0 auto;
  height: 100%;
  width: 100%;
}
</style>
